
import { getData, setData, updateAction,putSensorData } from '@/services/api'
import { updateContainerActions, formatDate } from '@/services/helper'
import store from '@/store/index'

// Global timeOut var prevents running it more than once at a time
var timeOutHandler



export function autoAssignContainer(expedient, actionName) {
    window.setTimeout(function(){
        getData('expedientes/' + expedient.internalId + '/actions/').then(result => {
            var actions = result.data
            actions.forEach(action => {
                if(action.type == 'ASIGNACION_DE_CONTENEDOR'){
                    //expedient.contenedores[0].matricula_id = createPlateNumber()
                    expedient.contenedores[0].matricula_id = 'DFSU 226548 7'
                    setData('expedientes/', expedient)
                    var now = new Date(); 
                    updateAction(expedient.internalId, "ASIGNACION_DE_CONTENEDOR", now, action.id).then(res => {
                        updateAction(expedient.internalId, "AVISO_A_TRANSPORTISTA", "pending", '').then(r => {
                            // Notification
                            var formatedDate = formatDate(String(now))
                            var notification = {
                                visible: true,
                                container: expedient.contenedores[0].matricula_id,
                                text: 'ha asignado el contenedor con matrícula ' + expedient.contenedores[0].matricula_id + ' y ha reservado un espacio en viaje.',
                                user: 'Maersk',
                                date: formatedDate,
                                color: '#9F0776',
                            }
                            store.dispatch('change_notification', notification)
                            putSensorData({"customName": expedient.contenedores[0].matricula_id, "vars": {"expediente": expedient.internalId}})

                            // Update actions
                            updateContainerActions(expedient.internalId)
                            return
                        })
                    })                                    
                }
            })
        })
    }, 4000);
}

export function autoLevante(expedientId) {
    window.setTimeout(function(){
        getData('expedientes/' + expedientId + '/actions/').then(result => {
            var actions = result.data
            actions.forEach(action => {
                if(action.type == 'AUTORIZACION_LEVANTE'){
                    var now = new Date(); 
                    updateAction(expedientId, "AUTORIZACION_LEVANTE", now, action.id).then(res => {
                        updateAction(expedientId, "CARGADO_EN_BUQUE", 'pending', '').then(r => {
                            // Notification
                            var formatedDate = formatDate(String(now))
                            var notification = {
                                visible: true,
                                container: 'DFSU 226548 7',
                                text: 'ha generado el documento "Autorización Levante"',
                                user: 'Aduana',
                                date: formatedDate,
                                color: '#9F0776',
                            }
                            store.dispatch('change_notification', notification)

                            // Update actions
                            updateContainerActions(expedientId)
                            autoCargadoEnBuque(expedientId)
                            return
                        })                      
                    })                                    
                }
            })
        })
    }, 4000);
}

export function autoCargadoEnBuque(expedientId) {
    window.setTimeout(function(){
        getData('expedientes/' + expedientId + '/actions/').then(result => {
            var actions = result.data
            actions.forEach(action => {
                if(action.type == 'CARGADO_EN_BUQUE'){
                    var now = new Date(); 
                    updateAction(expedientId, "CARGADO_EN_BUQUE", now, action.id).then(res => {
                        updateAction(expedientId, "REGISTRO_BILL_OF_LADING", 'pending', '').then(r => {
                            // Notification
                            var formatedDate = formatDate(String(now))
                            var notification = {
                                visible: true,
                                container: 'DFSU 226548 7',
                                text: 'ha cargado el contenedor "DFSU 226548 7" en el buque.',
                                user: 'Maersk',
                                date: formatedDate,
                                color: '#9F0776',
                            }
                            store.dispatch('change_notification', notification)

                            // Update actions
                            updateContainerActions(expedientId)
                            return
                        })                      
                    })                                    
                }
            })
        })
    }, 10000);
}

function createPlateNumber (expedient){
    var min = Math.ceil(10000000)
    var max = Math.floor(99999999)
    var containerPlate1 = Math.floor(Math.random() * (max - min + 1)) + min
    min = Math.ceil(0)
    max = Math.floor(8)
    var containerPlate2 = Math.floor(Math.random() * (max - min + 1)) + min
    var plateNumber = 'MAEU ' + containerPlate1 + ' ' + containerPlate2
    return plateNumber
}

export function infiniteUpdateStatus (internalId){
    console.log("TAB: " + store.getters.container_view_selected_tab)
    window.clearTimeout(timeOutHandler);
    if(store.getters.container_view_selected_tab != 'tracking') {       
        return
    }
    console.log("Updating " + internalId + "...")
    updateContainerActions(internalId)
    timeOutHandler = window.setTimeout(function(){
        infiniteUpdateStatus (internalId)
    }, 5000);
}